module.exports = __webpack_public_path__ + "img/dalmacijaNews.a9b90496.png";